/**
 * Client-side role helpers — UX routing only.
 *
 * The identity model (enforced server-side, see DOCS/SCHEMA.md):
 *   - One user ↔ one workspace: profiles.tenant_id
 *   - Workspace role:            profiles.role  ('owner' | 'admin' | 'member' | 'employee')
 *   - Platform superadmin:       profiles.global_role = 'superadmin'
 *
 * profiles.tenant_id / role / global_role are protected by a BEFORE UPDATE
 * trigger (guard_profile_security_fields); RLS policies are the actual
 * authorization layer. Nothing here grants access — it only decides what UI
 * to show. Never derive roles from auth metadata or other tables.
 */

export interface Profile {
  id: string
  global_role?: string
  role?: string
  tenant_id?: string
  email?: string
  name?: string
}

/** True when the profile has platform-wide superadmin privileges. */
export function isGlobalSuperadmin(profile?: Profile | null): boolean {
  return profile?.global_role === 'superadmin'
}
